import React from "react";
import { useTranslation } from "./hooks/useTranslation";
export var LoadingScreen = function (_a) {
    var message = _a.message;
    var t = useTranslation();
    return (React.createElement("div", { className: "loading-screen" },
        React.createElement("div", { className: "icon" },
            React.createElement("div", { className: "lds-default" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null))),
        React.createElement("div", { className: "text" }, message || "".concat(t("Loading"), "..."))));
};
